import { render, staticRenderFns } from "./rejectIcon.vue?vue&type=template&id=281e45f7&"
import script from "./rejectIcon.vue?vue&type=script&lang=js&"
export * from "./rejectIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports